module.exports = __webpack_public_path__ + "static/media/Slowking_gaussian2.ff0a41c6.png";